import {
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { makeStyles } from "@mui/styles";
import { images } from "../components/imageSlider";
import "../components/repair.css";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Autocomplete from "@mui/material/Autocomplete";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
const useStyles = makeStyles((theme) => ({
  imgStyle: {
    height: 200,
    width: 250,
    margin: "0px 5px 0px 5px",
    border: "1px solid black ",
  },
}));

export default function RepairEditAndCreate() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  const [LocationList, setLocationList] = useState([]);
  const [currImg, setCurrImg] = useState(0);
  const [Submitting, setSubmitting] = useState(false);
  const [customer_data, setCustomer_data] = useState([]);
  const [customer_id, setCustomer_id] = useState("");
  const [repair_data, setRepair_data] = useState([]);
  const [imageRepair, setImage_Repair] = useState([]);
  let { id } = useParams();
  const data_params = { id: id };
  const [ModalImageopen, setOpenModalImage] = useState(false);
  const handleModalOpen = () => setOpenModalImage(true);
  const handleModalClose = () => setOpenModalImage(false);
  const [ImageSrcOpen, setImageSrcOpen] = useState("");
  const [url, setUrl] = useState("");
  async function init() {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setUrl(results);
  }

  const [Files, setFiles] = useState([]);

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  //fetch Customer Data
  const getCustomer_Data = async () => {
    const params = {
      cusType: 2,
    };
    try {
      const data = await api.post("api/customer/list", params);
      setCustomer_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getDataRepairList = async () => {
    try {
      const data = await api.post("api/repair/detail", data_params);
      data.data.map((res) => {
        setRepair_data(res);
      });
    } catch (e) {
      console.log(e);
    }
  };
  const getImage = async () => {
    try {
      const data = await api.post("api/repair/file", data_params);
      setImage_Repair(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getCustomer_Data();
    if (id) {
      getDataRepairList();
      getImage();
    }
    init()
  }, []);
  const {
    getRootProps: getRootPropsBefore,
    getInputProps: getInputPropsBefore,
  } = useDropzone({
    accept: "image/*",
    onDrop: async (acceptedFiles) => {
      acceptedFiles.map((res) => {
        fileUpload(res, 1);
        // console.log(1);
      });
    },
  });
  const { getRootProps: getRootPropsAfter, getInputProps: getInputPropsAfter } =
    useDropzone({
      accept: "image/*",
      onDrop: async (acceptedFiles) => {
        acceptedFiles.map((res) => {
          fileUpload(res, 2);
          // console.log(2);
        });
      },
    });

  const fileUpload = (acceptedFiles, type) => {
    let formData = new FormData();
    formData.append("fileUpload", acceptedFiles);
    formData.append("repairId", id);
    formData.append("uploadType", type);
    formData.append("createId", EmpId);

    api
      .post("api/repair/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          getImage();
          return MySwal.fire("สำเร็จ!", "เพิ่ม รูปภาพ สำเร็จ !", "success");
        });

      })
      .catch(() => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "error",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("ล้มเหลว!", "เพิ่ม ไฟล์ ไม่สำเร็จ !", "error");
        });
      });
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      repair_no: repair_data?.ContainerRepairNo
        ? repair_data?.ContainerRepairNo
        : "",
      container: repair_data?.ContainerNo ? repair_data?.ContainerNo : "",
       customer_id: repair_data?.CustomerId ? repair_data?.CustomerId : "",
      so_id: repair_data?.SoNo ? repair_data?.SoNo : "",
      booking_id: repair_data?.Booking ? repair_data?.Booking : "",
      voyage: repair_data?.Voyage ? repair_data?.Voyage : "",
      size_type: repair_data?.Size ? repair_data?.Size : "",
      grade: repair_data?.ContainerGrade ? repair_data?.ContainerGrade : "",
      repair_type: repair_data?.RepairType ? repair_data?.RepairType : "",
      charge: repair_data?.ContainerChange ? repair_data?.ContainerChange : "",
      amout: repair_data?.Amount ? repair_data?.Amount : "",
      before_remark: repair_data?.DetailBefore ? repair_data?.DetailBefore : "",
      after_remark: repair_data?.DetailAfter ? repair_data?.DetailAfter : "",
    },
    onSubmit: (values) => {
      const createId = EmpId;
      setSubmitting(true);
      setTimeout(() => {
        if (id) {
          const data = {
            id: id,
            containerNo: values.container,
            cusId: repair_data?.CustomerId,
            soNo: values.so_id,
            booking: values.booking_id,
            voyage: values.voyage,
            size: values.size_type,
            grade: values.grade,
            repairType: values.repair_type,
            change: values.charge,
            amount: values.amout,
            remarkBefore: values.before_remark,
            remarkAfter: values.after_remark,
            ModId: EmpId,
          };
          api
            .post("api/repair/update", data)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "แก้ไขรายการซ่อมแซมสำเร็จ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(respose.data.id);
                    getDataRepairList();
                    // history.push("/ContainerRepair/RepairList");
                  }
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          const data = {
            containerNo: values.container,
            cusId: customer_id,
            soNo: values.so_id,
            booking: values.booking_id,
            voyage: values.voyage,
            size: values.size_type,
            grade: values.grade,
            repairType: values.repair_type,
            change: values.charge,
            amount: values.amout,
            remarkBefore: values.before_remark,
            remarkAfter: values.after_remark,
            createId,
          };
          api
            .post("api/repair/create", data)
            .then((respose) => {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "success",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "สำเร็จ!",
                  "เพิ่มรายการซ่อมแซมสำเร็จ !",
                  "success"
                ).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(respose.data.id);
                    history.push(
                      "/ContainerRepair/Repair/Edit/" + respose.data.id
                    );
                    // history.push("/ContainerRepair/RepairList");
                  }
                });
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }

        setSubmitting(false);
      }, 400);
    },
  });
  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          maxHeight: "86vh",
          overflow: "auto",
        }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการซ่อมตู้คอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Repair List
            </Typography>
          </Grid>

          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Container Repair</Typography>
            <Typography className="textcolorBule">
              <span>&nbsp;</span> / Repair List
            </Typography>
            <Typography>
              <span>&nbsp;</span> / {id ? "Detail " : "Create"}
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{ justifyContent: "right", display: "flex" }}>
          {id ? (
            <h4 className="textcolorgreen">
              #{repair_data?.ContainerRepairNo} ||{" "}
              {repair_data?.Approve == 1 ? "APPROVE" : "WAIT FOR APPROVE"}
            </h4>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          <h5
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            className="textcolorgreen"
          ></h5>
        </Grid>

        <form onSubmit={formik.handleSubmit}>
          <Grid sx={{ padding: "30px 70px 30px 70px" }}>
            {id ? (
              <Grid item xs={12}>
                <p className="textcolordarkblue">Container Repair Edit</p>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <p className="textcolordarkblue">Container Repair Create</p>
              </Grid>
            )}

            <Grid container spacing={3}>
              {/* <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="repair_no"
                  label="Repair No."
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.repair_no}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                {id ? (
                  <TextField
                    name="customer_name"
                    label="CUSTOMER NAME"
                    variant="outlined"
                    placeholder="Customer Name"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    value={repair_data?.CustomerName}
                    InputLabelProps={{
                      shrink: true,
                      readonly: true,
                      disabled: true,
                    }}
                    classes={{ root: classes.customOutline }}
                    disabled={true}
                    fullWidth
                  />
                ) : (
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={customer_data}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(x, y) => setCustomer_id(y.CustomerId)}
                    getOptionLabel={(option) => option.CustomerName}
                    renderInput={(params) => (
                      <TextField
                        name="customer_name"
                        label="CUSTOMER NAME"
                        variant="outlined"
                        placeholder="Customer Name"
                        required
                        onChange={formik.handleChange}
                        value={formik.values.customer_id}
                        InputLabelProps={{ shrink: true }}
                        classes={{ root: classes.customOutline }}
                        {...params}
                        fullWidth
                      />
                    )}
                  />
                )}

                {/* <TextField
                      name="customer_name"
                      label="CUSTOMER NAME"
                      variant="outlined"
                      placeholder="Customer Name"
                      required
                      onChange={formik.handleChange}
                      value={formik.values.customer_id}
                      InputLabelProps={{ shrink: true }}
                      classes={{ root: classes.customOutline }}
                   
                      fullWidth
                    /> */}
                {/* <TextField
                  name="customer_id"
                  label="Customer Name"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.customer_id}
                /> */}
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  name="container"
                  label="Container"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.container}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="so_id"
                  label="SO"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.so_id}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="booking_id"
                  label="Booking"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.booking_id}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="voyage"
                  label="Voyage"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.voyage}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="size_type"
                  label="Size type"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.size_type}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="grade"
                  label="Grade"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.grade}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel id="locationFrom">Repiar Type</InputLabel>
                  <Select
                    name="repair_type"
                    value={formik.values.repair_type}
                    label="Repiar Type"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={formik.handleChange}
                    disabled={repair_data?.Approve == 1}
                  >
                    <MenuItem value="1">อัพเกรดตู้</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel id="locationFrom">Charge</InputLabel>
                  <Select
                    name="charge"
                    value={formik.values.charge}
                    label="Charge"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={formik.handleChange}
                    disabled={repair_data?.Approve == 1}
                  >
                    <MenuItem value="1">EX-charge</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <TextField
                  name="amout"
                  label="Amout"
                  variant="outlined"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.amout}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
            </Grid>

            <Grid item xs sx={{ marginTop: 3, marginBottom: 2 }}>
              <Typography className="textcolordarkblue" component="h1">
                รายละเอียดการซ่อมแซม
                <span className="textcolorRed">&nbsp;*</span>
              </Typography>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} lg={6} sx={{ marginBottom: 3 }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  name="before_remark"
                  label="Before รายละเอียด (ก่อน)"
                  variant="outlined"
                  style={{
                    width: "100%",
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.before_remark}
                  disabled={repair_data?.Approve == 1}
                />
              </Grid>
              <Grid item xs={12} lg={6} sx={{ marginBottom: 3 }}>
                <TextField
                  multiline
                  fullWidth
                  rows={4}
                  name="after_remark"
                  label="After รายละเอียด (หลัง)"
                  variant="outlined"
                  style={{
                    width: "100%",
                  }}
                  disabled={repair_data?.Approve == 1}
                  InputLabelProps={{ shrink: true }}
                  onChange={formik.handleChange}
                  value={formik.values.after_remark}
                />
              </Grid>
            </Grid>

            {id ? (
              <Grid container spacing={3}>
                <Grid item xs={12} lg={6} sx={{ marginBottom: 3 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: 20,
                    }}
                  >
                    <div
                      {...getRootPropsBefore()}
                      // onClick={() => {
                      //   setUploadType("1");
                      // }}
                    >
                      <input
                        {...getInputPropsBefore()}

                        // type="file"
                      />

                      <div
                        style={{
                          border: "4px dotted #28A745 ",
                          width: 200,
                          height: 200,
                          borderRadius: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span
                            style={{ color: "#28A745", fontSize: 50 }}
                            className="material-icons-outlined"
                          >
                            perm_media
                          </span>
                          <span style={{ color: "#28A745" }}>Browse</span>
                        </div>
                      </div>
                    </div>
                    <Grid item xs={12} lg={4}>
                      <div
                        style={{
                          display: "flex",
                          width: 400,
                          maxWidth: 400,
                          overflowY: "auto",
                          marginLeft: 20,
                          boxShadow: "5px 5px 10px #888888",
                          borderRadius: "5px",
                        }}
                      >
                        {imageRepair
                          .filter((img) => img.type == "1")
                          .map((img, index) => {
                            // console.log(img);
                            return (
                              <>
                                <Grid item xs={12} lg={4}>
                                  <img
                                    className={classes.imgStyle}
                                    src={
                                      url.REACT_APP_BASE_API + img.path
                                    }
                                    alt="imgBefor"
                                    onClick={() => {
                                      handleModalOpen();
                                      setImageSrcOpen(
                                        url.REACT_APP_BASE_API +
                                          img.path
                                      );
                                    }}
                                  />
                                  <Box textAlign="center">
                                    <Button
                                      sx={{ m: 1 }}
                                      variant="contained"
                                      onClick={() => {
                                        const swalWithBootstrapButtons =
                                          Swal.mixin({
                                            customClass: {
                                              confirmButton:
                                                "btn btn-success ml-5",
                                              cancelButton:
                                                "btn btn-danger ml-5",
                                            },
                                            buttonsStyling: false,
                                          });

                                        swalWithBootstrapButtons
                                          .fire({
                                            title: "คุณต้องการที่จะลบรูปภาพ ?",
                                            text: "หากคุณลบภาพนี้จะไม่สามารถนำกลับมาใช้ได้อีก!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: "ใช่ !",
                                            cancelButtonText: "ยกเลิก",
                                            reverseButtons: true,
                                          })
                                          .then((result) => {
                                            if (result.isConfirmed) {
                                              const params = {
                                                id: img.id,

                                                ModId: EmpId,
                                              };
                                              api
                                                .post(
                                                  "api/repair/file/delete",
                                                  params
                                                )
                                                .then((respose) => {
                                                  const MySwal =
                                                    withReactContent(Swal);

                                                  MySwal.fire({
                                                    icon: "success",
                                                    didOpen: () => {
                                                      MySwal.clickConfirm();
                                                    },
                                                  }).then(() => {
                                                    return MySwal.fire(
                                                      "ลบรายการสำเร็จ!",
                                                      "ดำเนินการเสร็จสิ้นรูปภาพของคุณถูกลบเรียบร้อย !",
                                                      "success"
                                                    ).then((result) => {
                                                      if (result.isConfirmed) {
                                                        getImage();
                                                      }
                                                    });
                                                  });
                                                })
                                                .catch((err) => {
                                                  console.log(err);
                                                });
                                            } else if (
                                              result.dismiss ===
                                              Swal.DismissReason.cancel
                                            ) {
                                            }
                                          });
                                      }}
                                    >
                                      ลบ
                                    </Button>
                                  </Box>
                                </Grid>
                              </>
                            );
                          })}
                      </div>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ marginBottom: 3 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: 20,
                    }}
                  >
                    <div
                      {...getRootPropsAfter()}
                      // onClick={() => {
                      //   setUploadType("1");
                      // }}
                    >
                      <input
                        {...getInputPropsAfter()}

                        // type="file"
                      />

                      <div
                        style={{
                          border: "4px dotted #28A745 ",
                          width: 200,
                          height: 200,
                          borderRadius: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span
                            style={{ color: "#28A745", fontSize: 50 }}
                            className="material-icons-outlined"
                          >
                            perm_media
                          </span>
                          <span style={{ color: "#28A745" }}>Browse</span>
                        </div>
                      </div>
                    </div>
                    <Grid item xs={12} lg={4}>
                      <div
                        style={{
                          display: "flex",
                          width: 400,
                          maxWidth: 400,
                          overflowY: "auto",
                          marginLeft: 20,
                          boxShadow: "5px 5px 10px #888888",
                          borderRadius: "5px",
                        }}
                      >
                        {imageRepair
                          .filter((img) => img.type == "2")
                          .map((img, index) => {
                            // console.log(img);
                            return (
                              <>
                                <Grid item xs={12} lg={4}>
                                  <img
                                    className={classes.imgStyle}
                                    src={
                                      url.REACT_APP_BASE_API + img.path
                                    }
                                    alt="imgAfter"
                                    onClick={() => {
                                      handleModalOpen();
                                      setImageSrcOpen(
                                        url.REACT_APP_BASE_API +
                                          img.path
                                      );
                                    }}
                                  />
                                  <Box textAlign="center">
                                    <Button
                                      sx={{ m: 1 }}
                                      variant="contained"
                                      onClick={() => {
                                        const swalWithBootstrapButtons =
                                          Swal.mixin({
                                            customClass: {
                                              confirmButton:
                                                "btn btn-success ml-5",
                                              cancelButton:
                                                "btn btn-danger ml-5",
                                            },
                                            buttonsStyling: false,
                                          });

                                        swalWithBootstrapButtons
                                          .fire({
                                            title: "คุณต้องการที่จะลบรูปภาพ ?",
                                            text: "หากคุณลบภาพนี้จะไม่สามารถนำกลับมาใช้ได้อีก!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: "ใช่ !",
                                            cancelButtonText: "ยกเลิก",
                                            reverseButtons: true,
                                          })
                                          .then((result) => {
                                            if (result.isConfirmed) {
                                              const params = {
                                                id: img.id,

                                                ModId: EmpId,
                                              };
                                              api
                                                .post(
                                                  "api/repair/file/delete",
                                                  params
                                                )
                                                .then((respose) => {
                                                  const MySwal =
                                                    withReactContent(Swal);

                                                  MySwal.fire({
                                                    icon: "success",
                                                    didOpen: () => {
                                                      MySwal.clickConfirm();
                                                    },
                                                  }).then(() => {
                                                    return MySwal.fire(
                                                      "ลบรายการสำเร็จ!",
                                                      "ดำเนินการเสร็จสิ้นรูปภาพของคุณถูกลบเรียบร้อย !",
                                                      "success"
                                                    ).then((result) => {
                                                      if (result.isConfirmed) {
                                                        getImage();
                                                      }
                                                    });
                                                  });
                                                })
                                                .catch((err) => {
                                                  console.log(err);
                                                });
                                            } else if (
                                              result.dismiss ===
                                              Swal.DismissReason.cancel
                                            ) {
                                            }
                                          });
                                      }}
                                    >
                                      ลบ
                                    </Button>
                                  </Box>
                                </Grid>
                              </>
                            );
                          })}
                      </div>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            ) : null}

            <Grid item xs={8} sm={12} sx={{ marginTop: 5 }}>
              <Button
                sx={{ width: 80 }}
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                Cancel
              </Button>
              
              {id ?  (
                <>
                   {repair_data?.Approve == 0 ? (
                  <Button
                    sx={{ width: 80 }}
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    // disabled={Submitting}
                  >
                    {Submitting && <CircularProgress size={22} />}
                    {!Submitting && "UPDATE"}
                  </Button>
                   ) :null
                   }
                  {repair_data?.Approve == 0 ? (
                    <Button
                      sx={{ width: 80 }}
                      // type="submit"
                      variant="contained"
                      style={{
                        background: "#30318D",
                        borderColor: "#30318D",
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        const params = {
                          id: id,
                          approve: 1,
                          ModId: EmpId,
                        };
                        api
                          .post("api/repair/approve", params)
                          .then((respose) => {
                            const MySwal = withReactContent(Swal);

                            MySwal.fire({
                              icon: "success",
                              didOpen: () => {
                                MySwal.clickConfirm();
                              },
                            }).then(() => {
                              return MySwal.fire(
                                "สำเร็จ!",
                                "อนุมัติรายการสำเร็จ !",
                                "success"
                              ).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(respose.data.id);
                                  // history.push(
                                  //   "/ContainerRepair/Repair/Edit/" + id
                                  // );
                                  getDataRepairList();

                                  // history.push("/ContainerRepair/RepairList");
                                }
                              });
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                      // disabled={Submitting}
                    >
                      {Submitting && <CircularProgress size={22} />}
                      {!Submitting && "Approve"}
                    </Button>
                  ) : null}
                </>
              ) : (
                <Button
                  sx={{ width: 80 }}
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  // disabled={Submitting}
                >
                  {Submitting && <CircularProgress size={22} />}
                  {!Submitting && "SAVE"}
                </Button>
              )}

              {/* <Button
                sx={{ width: 80 }}
                variant="contained"
                style={{
                  background: "#30318D",
                  borderColor: "#30318D",
                  marginRight: "10px",
                }}
                // onClick={() => changeStatusButton(3)}
              >
                Approve
              </Button> */}
            </Grid>
          </Grid>
        </form>
      </Card>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={ModalImageopen}
        onClose={handleModalClose}
        closeAfterTransition
      >
        <Fade in={ModalImageopen}>
          <Box sx={styleModal}>
            <Typography sx={{ mt: 2 }}>
              <img
                style={{ width: "500px", height: "500px" }}
                src={ImageSrcOpen}
                alt="imgModal"
              />
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
